import { render, staticRenderFns } from "./SalesApplicationRoute.vue?vue&type=template&id=d055946a&"
import script from "./SalesApplicationRoute.vue?vue&type=script&lang=ts&"
export * from "./SalesApplicationRoute.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports